/*
 * BRAND SEPARATION RULE (King Performance <-> CMI)
 * King Performance pages recommend ONLY King Performance products; CMI pages never recommend King products.
 * Applies to every <product-recommendations> element ("Related products" section and the
 * "Frequently bought together" complementary block). Blocked cards are removed before the
 * list is shown. Brand key mirrors snippets/rec-brand-key.liquid.
 */
window.WM_REC_GUARD = window.WM_REC_GUARD || (function () {
  // King pages: keep only King Performance products. CMI pages: drop anything King.
  function blocked(src, b) {
    if (src === "king") return b !== "king";
    if (src === "cmi") return b === "king" || b === "kingmix";
    return false;
  }
  var cache = {};

  function brandKey(p) {
    if (!p) return "";
    var v = (p.vendor || "").toLowerCase();
    var t = (p.title || "").toLowerCase();
    var tags = (p.tags || []).map(function (x) { return String(x).toLowerCase(); });
    var tk = t.replace(/king[\s-]?pins?/g, "");
    if (v.indexOf("king performance") > -1 || tags.indexOf("brand-king-performance") > -1) return "king";
    if (v === "cmi" || v.indexOf("cmi products") > -1 || v.indexOf("cmi precision") > -1 ||
        tags.indexOf("brand-cmi") > -1 || tags.indexOf("source-cmi") > -1 || /\bcmi\b/.test(t)) return "cmi";
    if (/\bking\b/.test(tk)) return "kingmix";
    return "";
  }

  function handleFromUrl(url) {
    var m = String(url || "").match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function brandForHandle(handle) {
    if (!handle) return Promise.resolve("");
    if (!cache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      cache[handle] = fetch(root + "products/" + encodeURIComponent(handle) + ".js")
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(brandKey)
        .catch(function () { return ""; });
    }
    return cache[handle];
  }

  function itemsOf(el) {
    var items = el.querySelectorAll("li.grid-item, .product-recommendation-list-row-item");
    return Array.prototype.slice.call(items);
  }

  function itemBrand(item) {
    var attr = item.getAttribute("data-rec-brand");
    if (attr !== null) return Promise.resolve(attr.trim());
    var a = item.querySelector('a[href*="/products/"]');
    return brandForHandle(a && handleFromUrl(a.getAttribute("href")));
  }

  function sourceBrand(el) {
    var attr = el.getAttribute("data-source-brand");
    if (attr) return Promise.resolve(attr.trim());
    return brandForHandle(handleFromUrl(window.location.pathname));
  }

  function guard(el) {
    el.style.visibility = "hidden";
    return sourceBrand(el).then(function (src) {
      var items = itemsOf(el);
      return Promise.all(items.map(itemBrand)).then(function (brands) {
        var max = parseInt(el.getAttribute("data-display-count"), 10) || Infinity;
        var shown = 0;
        items.forEach(function (item, i) {
          if (blocked(src, brands[i])) { item.remove(); return; }
          if (shown < max) { item.removeAttribute("data-rec-hidden"); shown++; }
          else { item.remove(); }
        });
        if (shown === 0 && items.length) { el.innerHTML = ""; }
      });
    }).catch(function () {}).then(function () { el.style.visibility = ""; });
  }

  return { guard: guard, brandKey: brandKey };
})();

if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations();
    }

    initializeRecommendations() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) {
          return;
        }

        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("product-recommendations");

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.style.visibility = "hidden";
              this.innerHTML = recommendations.innerHTML;
              return window.WM_REC_GUARD.guard(this).then(() => {
                if (this.querySelector(".card")) {
                  this.classList.add("product-recommendations-loaded");
                }
              });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
}